import React from "react";
import { Box, Stack, Typography } from "@mui/material";

export default function PageHeader({ title, subtitle, action, badge }) {
    return (
        <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            spacing={2}
            sx={{ mb: 3 }}
        >
            <Box>
                {badge ? (
                    <Typography
                        variant="overline"
                        sx={{
                            color: "primary.main",
                            fontWeight: 800,
                            letterSpacing: "0.14em",
                            display: "block",
                            mb: 0.5,
                        }}
                    >
                        {badge}
                    </Typography>
                ) : null}
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 800,
                        letterSpacing: "-0.03em",
                        color: "text.primary",
                        lineHeight: 1.15,
                    }}
                >
                    {title}
                </Typography>
                {subtitle ? (
                    <Typography variant="body1" color="text.secondary" sx={{ mt: 0.75, maxWidth: 640 }}>
                        {subtitle}
                    </Typography>
                ) : null}
            </Box>
            {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
        </Stack>
    );
}
